import EquipamentoFormPage from "./EquipamentoFormPage"

export default function EquipamentoForm() {
  return <EquipamentoFormPage />
}
